import { useGates } from '../../common/hooks/useGates';
import WebinarSelectionContainer from '../components/WebinarSelectionContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const WebinarSelection = props => {
  const {
    gates
  } = useGates();

  // After removing the gate, move all contents of WebinarSelectionContainer component to this component and also the FormLabelWithTooltip component
  return /*#__PURE__*/_jsx(WebinarSelectionContainer, Object.assign({}, props, {
    gates: gates
  }));
};
export default WebinarSelection;